import React from "react";
//indicates loading via a spinner or a shadow component
import { PageNotFound } from "./errorPages/ErrorPages";

export const LandingPage: React.FunctionComponent = () => {
  return <PageNotFound />;
};
